/* eslint-disable indent */
import React from 'react';
import moment from 'moment';
import Modal from 'react-modal';
import classnames from 'classnames';
import closeIcon from '../../../assets/images/x_icon_black.svg';
import checkMark from '../../../assets/images/check-mark-blue.svg';
import downchivron from '../../../assets/images/chevron-left.svg';

import './index.scss';
import utils from '../../../lib/utils';

Modal.setAppElement('#root');

const days_duration = [
  { value: 'P0D', label: 'Same Day' },
  { value: 'P1D', label: '1 Day before' },
  { value: 'P2D', label: '2 Days before' },
  { value: 'P3D', label: '3 Days before' },
  { value: 'P4D', label: '4 Days before' },
  { value: 'P5D', label: '5 Days before' },
  { value: 'P6D', label: '6 Days before' },
  { value: 'P7D', label: '1 Week before' },
];

const convertToChannelFormat = (selectedReminderChannels) => Object.fromEntries(selectedReminderChannels.map(({ period, channel }) => [period, `${channel}_REMINDER`]));

class CreateReminder extends React.Component {
  constructor(props) {
    super(props);
    this.closeModal = this.closeModal.bind(this);
    this.ref = React.createRef();
    this.triesref = React.createRef();
    this.state = {
      prebookingMessage: '',
      selectedServices: [],
      selectedReminders: [],
      selectedCustomReminders: [],
      selectedCustomServices: [],
      selectedReminderChannels: [],
      isServiceOpen: false,
      isTriesOpen: false,
      allServiceSelected: false,
    };
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  handleClickOutside = (event) => {
    if (this.ref.current && !this.ref.current.contains(event.target)) {
      this.setState({
        isServiceOpen: false,
      });
    }
    if (
      this.triesref.current &&
      !this.triesref.current.contains(event.target)
    ) {
      this.setState({
        isTriesOpen: false,
      });
    }
  };

  closeModal() {
    this.props.closeCampaignModel();
  }

  getServiceFiltered = (services) => {
    const { reminders } = this.props;
    let existingservices = [];
    const filtered_reminder =
      reminders.filter((reminder) => reminder.status !== 'DELETED') || [];
    for (let i = 0; i < filtered_reminder.length; i++) {
      let serviceIds = filtered_reminder[i].services.map(
        (service) => service.id,
      );
      existingservices = [...existingservices, ...serviceIds];
    }
    console.log('existingservices', existingservices);
    let filtedService = services.filter(
      (service) => !existingservices.includes(service.id),
    );
    let filteredService = filtedService.filter(
      (service) => service.kind === 'SESSION',
    );
    console.log('filteredService', filteredService);
    //filteredService.unshift(select_all);
    return filteredService;
  };

  onFieldChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  setAppointmentReminder = () => {
    const {
      prebookingMessage,
      selectedCustomServices,
      selectedCustomReminders,
      selectedReminderChannels,
    } = this.state;
    const { reminders, business } = this.props;
    const { details } = business;
    let serviceData = details?.services.filter((service) =>
      selectedCustomServices.includes(service.id),
    );
    const services = serviceData;
    const data = {
      appointment_reminders: [
        {
          services,
          staffs: [],
          days_before: selectedCustomReminders,
          first_message: '',
          followup_message: prebookingMessage,
          reminder_types_by_period: convertToChannelFormat(selectedReminderChannels),
        },
        ...reminders,
      ],
    };
    console.log('selectedReminders', data);
    this.props.addAppointmentReminder(data);
    this.closeModal();
  };

  setIsOpen = (field, flag) => {
    this.setState({
      [field]: flag,
    });
  };

  reminderDropdownHandler = (id) => {
    const { selectedCustomReminders, selectedReminderChannels } = this.state;
    let reminders = [...selectedCustomReminders];
    let reminderChannels = [...selectedReminderChannels];
    let index = reminders.indexOf(id);
    if (index !== -1) {
      reminders.splice(index, 1);
      reminderChannels = reminderChannels.filter(reminder => reminder.period !== id);
    } else {
      if (selectedCustomReminders.length < 3) {
        reminders.push(id);
        reminderChannels.push({ period: id, channel: 'TEXT' });
      }
    }
    this.setState({
      selectedCustomReminders: reminders,
      selectedReminderChannels: reminderChannels,
    });
  };
  
  changeChannel = (period, channel) => {
    const { selectedReminderChannels } = this.state;
    let reminderChannels = [...selectedReminderChannels];

    const index = reminderChannels.findIndex(reminder => reminder.period === period);

    if (index !== -1) {
      reminderChannels[index] = { period, channel };
    } else {
      reminderChannels.push({ period, channel });
    }

    this.setState({ selectedReminderChannels: reminderChannels });
  }
  serviceDropdownHandler = (id) => {
    const { selectedCustomServices } = this.state;
    let services = [...selectedCustomServices];
    let index = services.indexOf(id);
    if (index !== -1) {
      services.splice(index, 1);
    } else {
      services.push(id);
    }
    this.setState({
      selectedCustomServices: services,
    });
  };
  onSelectAll = () => {
    const { business } = this.props;
    const { details } = business;
    const filtered_services = this.getServiceFiltered(details.services);
    const selectedCustomServices = filtered_services.map(
      (service) => service.id,
    );
    this.setState({
      selectedCustomServices,
      allServiceSelected: true,
    });
  };
  onDeSelectAll = () => {
    this.setState({
      selectedCustomServices: [],
      allServiceSelected: false,
    });
  };
  getServiceNameforId = (services) => {
    const { business } = this.props;
    let serviceList = '';
    const maxLength = services.length < 5 ? services.length : 5;
    for (let i = 0; i < maxLength; i++) {
      serviceList += business?.serviceById[services[i]]?.name + ' ';
      serviceList += i < maxLength - 1 ? ', ' : '';
    }
    if (services.length > 5) {
      serviceList += `& ${services.length - 5} more`;
    }
    return serviceList || '';
  };

  render() {
    const { modelopen, auth, isLoading, business } = this.props;
    const { details } = business;
    const { domain, booking_software } = auth;
    const {
      selectedServices,
      selectedCustomServices,
      selectedReminders,
      prebookingMessage,
      isServiceOpen,
      allServiceSelected,
      isTriesOpen,
      selectedCustomReminders,
      selectedReminderChannels,
    } = this.state;
    console.log('selectedReminderChannels', selectedReminderChannels);
    const duration_dropdown_list =
      booking_software === 'BOULEVARD' ? days_duration.slice(0, 3) : days_duration;
    const voiceEnabled = utils.getCookie('features')?.includes("VOICE_REMINDER_ENABLED");
    return (
      <div>
        <Modal
          isOpen={modelopen}
          onAfterOpen={this.afterOpenModal}
          onRequestClose={this.closeModal}
          className="Modal"
          overlayClassName="Overlay"
          contentLabel="Example Modal"
        >
          <div>
            <div className="modal-header">
              <div className="title">Add reminders</div>
              <button className="modal-close" onClick={this.closeModal}>
                <img src={closeIcon}></img>
              </button>
              {domain !== 'DENTAL' && (
                <div className="input">
                  <label className="label">Service Type(s)*</label>
                  <div className="custom-select" ref={this.ref}>
                    <div
                      className="select-view"
                      onClick={() =>
                        this.setIsOpen('isServiceOpen', !isServiceOpen)
                      }
                    >
                      <div className="list-name">
                        {selectedCustomServices.length < 1
                          ? 'Select'
                          : this.getServiceNameforId(selectedCustomServices)}
                      </div>
                      <div className="dropdown-icon">
                        <img src={downchivron} />
                      </div>
                    </div>
                    {isServiceOpen && (
                      <div className="options-list">
                        <div className="select-all">
                          <div className="select-all_title">
                            Service Type(s)
                          </div>
                          {allServiceSelected ? (
                            <div
                              className="select-all_action"
                              onClick={this.onDeSelectAll}
                            >
                              Deselect all
                            </div>
                          ) : (
                            <div
                              className="select-all_action"
                              onClick={this.onSelectAll}
                            >
                              Select all
                            </div>
                          )}
                        </div>
                        {this.getServiceFiltered(details.services).map(
                          (service, index) => (
                            <div
                              className="option-item"
                              key={index}
                              onClick={() =>
                                this.serviceDropdownHandler(service.id)
                              }
                            >
                              <div
                                className={`checkbox ${
                                  selectedCustomServices.includes(service.id)
                                    ? 'checked'
                                    : ''
                                }`}
                              >
                                {selectedCustomServices.includes(
                                  service.id,
                                ) && <img src={checkMark} />}
                              </div>
                              <div className="service-name">{service.name}</div>
                            </div>
                          ),
                        )}
                      </div>
                    )}
                  </div>
                </div>
              )}
              <div className="input">
                <label className="label">
                  Is there a specific message you would like TrueLark to share
                  after confirming the appointment (e.g. what to wear, what to
                  bring)?
                </label>
                <textarea
                  placeholder="Post-confirmation message"
                  name="prebookingMessage"
                  value={prebookingMessage}
                  onChange={this.onFieldChange}
                ></textarea>
              </div>
              <div className="input">
                <label className="label">
                  When would you like to send the reminders? (max 3) *
                </label>
                  <div className="item-list">
                      {duration_dropdown_list.map((duration, index) => (
                        <div
                          className="option-item"
                          key={index}
                        >
                          <div className="checbox-group" onClick={() =>this.reminderDropdownHandler(duration.value)}>
                            <div
                              className={`checkbox ${selectedCustomReminders.includes(duration.value)
                                  ? 'checked'
                                  : ''
                                }`}
                            >
                              {selectedCustomReminders.includes(
                                duration.value,
                              ) && <img src={checkMark} />}
                            </div>
                            <div className="service-name">{duration.label}</div>
                          </div>
                          {selectedCustomReminders.includes(duration.value) &&
                            <div className={classnames('type-sector', { 'disable-voice':!voiceEnabled })}>
                              <div className="design-config">
                                <div className="selection">
                                  <div className="radio-section">
                                    <div className="radio-group" onClick={() => this.changeChannel(duration.value,'TEXT')}>
                                      <div className="radio-outer">
                                        <div className={classnames({'radio-inner': selectedReminderChannels.find(reminder => reminder.period === duration.value)?.channel === 'TEXT'})}> </div>
                                      </div>
                                      <div className="disp-value">SMS</div>
                                    </div>
                                  </div>
                                  <div className="radio-section">
                                    <div className="radio-group" onClick={() => this.changeChannel(duration.value,'VOICE')}>
                                      <div className="radio-outer">
                                        <div className={classnames({ 'radio-inner': selectedReminderChannels.find(reminder => reminder.period === duration.value)?.channel === 'VOICE' })}> </div>
                                      </div>
                                      <div className="disp-value">Voice</div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>}
                        </div>
                      ))}
                </div>
                {voiceEnabled && <div className='note'><span>Note:</span><span>Voice reminders will be delivered to landline users on all selected days.</span></div>}
              </div>
              <div className="actions">
                <button
                  className="btn btn--primary btn--lg"
                  onClick={this.setAppointmentReminder}
                  disabled={
                    selectedCustomReminders.length < 1 ||
                    (selectedCustomServices.length < 1 && domain !== 'DENTAL')
                  }
                >
                  SAVE
                </button>
                <button
                  className="btn btn--secondary btn--lg"
                  onClick={this.closeModal}
                >
                  CANCEL
                </button>
              </div>
            </div>
          </div>
          {this.props.children}
        </Modal>
      </div>
    );
  }
}

export default CreateReminder;
